/**
 * Global helper to open Paystack's hosted checkout in an in-app rounded
 * modal (mounted once at the App root by `PaystackCheckoutModal`).
 *
 * Call sites just do:
 *   import { openPaystackCheckout } from "@/utils/paystackCheckout";
 *   openPaystackCheckout(url);
 *
 * If the modal isn't mounted for any reason (e.g. deep-link entry point
 * that skipped `<App>`), we fall back to a full-page redirect so the
 * payment never gets stranded.
 */
export const PAYSTACK_CHECKOUT_EVENT = "yorm:paystack-checkout";

export function openPaystackCheckout(authorizationUrl) {
  if (!authorizationUrl) return;
  try {
    let handled = false;
    const evt = new CustomEvent(PAYSTACK_CHECKOUT_EVENT, {
      detail: {
        authorizationUrl,
        // The mounted modal flips this to true synchronously in its
        // handler so we know it picked the event up.
        ack: () => { handled = true; },
      },
    });
    window.dispatchEvent(evt);
    if (!handled) {
      // No listener responded — fall back to legacy full-page redirect
      // rather than silently swallowing the payment.
      window.location.href = authorizationUrl;
    }
  } catch (_e) {
    window.location.href = authorizationUrl;
  }
}
